  <div>
   <nav id="wb-bc" property="breadcrumb">
     <div class="row">
        <div [ngClass]="lastLoggedOut ? 'col-md-7' : 'col-md-12'">
          <ol class="breadcrumb carm-breadcrumbs">
            <li *ngFor="let level of levels"><a [carmRouterLink]="level.link" attr.data-cy="{{ level.dataCy }}" >{{ level.localizationKey | translate }}</a></li>
          </ol>
        </div>
        <div *ngIf="lastLoggedOut" class="col-md-5 last-logged-div">
          <span>{{ 'application_features.lastLoggedOut' | translate }} {{ lastLoggedOut |  date :'yyyy-MM-dd HH:mm' }} {{ 'application_features.easternStandardTime' | translate }}</span>
        </div>
      </div>
    </nav>
</div>
